import React, { Component } from 'react';

import './style.css';

const Neighbourhoods = [
  'Carapachay',
  'Florida Este',
  'Florida Oeste',
  'La Lucila',
  'Munro',
  'Olivos',
  'Vicente López',
  'Villa Adelina',
  'Villa Martelli',
];

const errors = {
  email_verification: 'email_verification'
};

class AddressForm extends Component {
  constructor() {
    super();
    this.onCityChange = this.onCityChange.bind(this);
    this.state = {};
  }

  onCityChange(e) {
    this.setState({city: e.target.value});
  }

  render() {

    return <React.Fragment>
      <div className="row">
      <div className="col-12 col-md-6">
        <div className="form-group">
          <label htmlFor="city">Localidad</label>
          <select required name={`${this.props.prefix}_city`} onChange={ this.onCityChange } className="form-control">
            <option>Selecciona una Localidad</option>
            <option value="vicente lopez">Vicente Lopez</option>
            <option value="otro">Otro</option>
          </select>
        </div>
      </div>
        <div className="col-12 col-md-6">
          <div className="form-group">
            <label htmlFor="neighbourhood">Barrio</label>
            { this.state.city === 'vicente lopez'
             ? <select name={`${this.props.prefix}_neighbourhood`} required className="form-control">
                <option>Selecciona un Barrio</option>
                {
                  Neighbourhoods
                    .map((n, i) => <option key={i} value={n}>{n}</option>)
                }
              </select>
              : <input required type="string" name={`${this.props.prefix}_neighbourhood`} className="form-control" placeholder="Caballito" />
            }
          </div>
      </div>
      </div>

        <div className="row">
          <div className="col-12 col-md-6">
            <div className="form-group">
              <label htmlFor="city">Dirección</label>
              <input required type="string" name={`${this.props.prefix}_address`} className="form-control" placeholder="Maipu" />
            </div>
          </div>

          <div className="col-md-3">
            <div className="form-group">
              <label htmlFor="city">Numero</label>
              <input required type="string" name={`${this.props.prefix}_address_number`} className="form-control" placeholder="3144" />
            </div>
          </div>

          <div className="col-md-3">
            <div className="form-group">
              <label htmlFor="city">Piso/Dpto</label>
              <input type="string" name={`${this.props.prefix}_address_dpto`} className="form-control" placeholder="1 B" />
            </div>
          </div>
  </div>
  </React.Fragment>
  }
}

AddressForm.defaultProps = {
  prefix: ''
}

class DNIForm extends Component {
  render() {
    return <div className="row">
      <div className="col-12 col-md-6">
        <div className="form-group">
          <label htmlFor={`${this.props.prefix}_docType`}>Tipo Documento</label>
          <select required name={`${this.props.prefix}_docType`} className="form-control">
            <option>Selecciona un tipo de documento</option>
            <option name={`${this.props.prefix}_docType`} value="dni">DNI</option>
            <option name={`${this.props.prefix}_docType`} value="pasaporte">Pasaporte</option>
            <option name={`${this.props.prefix}_docType`} value="otro">Otro</option>
          </select>
        </div>
      </div>
      <div className="col-12 col-md-6">
        <div className="form-group">
        <label htmlFor={`${this.props.prefix}_doc`}>Numero</label>
        <input required type="string" name={`${this.props.prefix}_doc`} className="form-control" placeholder="33132452" />
      </div>
    </div>
    </div>
  }
}

DNIForm.defaultProps = {
  prefix: ''
}

class UnderAgeApplicant extends Component {
  render() {
    return <React.Fragment>
      <fieldset>
        <legend>Datos del aspirante</legend>
        <div className="row">
          <div className="col-12 col-md-6">
            <div className="form-group">
              <label htmlFor="name">Nombre</label>
              <input required type="string" name="name" className="form-control" placeholder="Nombre" />
            </div>
          </div>
          <div className="col-12 col-md-6">
            <div className="form-group">
              <label htmlFor="name">Apellido</label>
              <input required type="string" name="lastname" className="form-control" placeholder="Apellido" />
            </div>
          </div>
        </div>
        <DNIForm />
        <AddressForm />
      </fieldset>
      <hr />
      <fieldset>
        <legend>Datos del Padre / Madre / Tutor o Adulto Responsable</legend>
        <div className="row">
          <div className="col-12 col-md-6">
            <div className="form-group">
              <label htmlFor="mandated_name">Nombre</label>
              <input required name="mandated_name" type="string" className="form-control" placeholder="Nombre" />
            </div>
          </div>
          <div className="col-12 col-md-6">
            <div className="form-group">
              <label htmlFor="mandated_name">Apellido</label>
              <input required name="mandated_lastname" type="string" className="form-control" placeholder="Apellido" />
            </div>
          </div>
        </div>
        <div className="row">
          <div className="col-12 col-md-6">
            <div className="form-group">
              <label htmlFor="mail">E-mail</label>
              <input required type="string" name="mandated_email" className={`form-control ${this.props.error === errors.email_verification  ? 'email_error' : null}`} placeholder="E-mail" />
            </div>
          </div>
          <div className="col-12 col-md-6">
            <div className="form-group">
              <label htmlFor="mandated_repeat_email">Repetir E-mail</label>
              <input required type="mail" name="mandated_repeat_email" className={`form-control ${this.props.error === errors.email_verification  ? 'email_error' : null}`} placeholder="E-mail" />
            </div>
          </div>
        </div>
          <div className="form-group">
            <label htmlFor="mandated_telephone">Telefono</label>
            <input required type="telephone" name="mandated_telephone" className="form-control" placeholder="Telefono" />
          </div>
        <DNIForm prefix="mandated" />
        <AddressForm prefix="mandated" />
    </fieldset>
  </React.Fragment>
  }
}

class AdultApplicant extends Component {
  render () {
    return <React.Fragment>
    <fieldset>
      <legend>Datos del aspirante</legend>
      <div className="row">
        <div className="col-12 col-md-6">
          <div className="form-group">
            <label htmlFor="name">Nombre</label>
            <input required type="string" name="name" className="form-control" placeholder="Nombre" />
          </div>
        </div>
        <div className="col-12 col-md-6">
          <div className="form-group">
            <label htmlFor="lastname">Apellido</label>
            <input required type="string" name="lastname" className="form-control" placeholder="Apellido" />
          </div>
        </div>
      </div>
      <div className="row">
        <div className="col-12 col-md-6">
          <div className="form-group">
            <label htmlFor="email">E-mail</label>
            <input required type="email" name="email" className={`form-control ${this.props.error === errors.email_verification  ? 'email_error' : null}`} placeholder="juan@example.com" />
          </div>
        </div>
        <div className="col-12 col-md-6">
          <div className="form-group">
              <label htmlFor="repeat_email">Repetir E-mail</label>
              <input required type="email" name="repeat_email" className={`form-control ${this.props.error === errors.email_verification  ? 'email_error' : null}`} placeholder="juan@example.com" />
          </div>
        </div>
      </div>
      <div className="row">
        <div className="col">
          <div className="form-group">
            <label htmlFor="telephone">Telefono</label>
            <input required type="telephone" name="telephone" className="form-control" placeholder="1566981235" />
          </div>
        </div>
      </div>
      <DNIForm />
      <AddressForm />
    </fieldset>
  </React.Fragment>
  }
}


class AspiranteForm extends Component {

  constructor() {
    super();
    this.onFormChange = this.onFormChange.bind(this);
    this.onFormSubmit = this.onFormSubmit.bind(this);
    this.state = { applicant: {} };
  }

  onFormChange(e) {
    const name = e.target.name;
    const value = e.target.value;

    this.setState((prev, props) => {
      const newState = { ...prev };
      newState.applicant[name] = value;
      return newState;
    });
  }

  onFormSubmit(e) {
    e.preventDefault();

    if (this.state.applicant.email !== this.state.applicant.repeat_email || this.state.applicant.mandated_email !== this.state.applicant.mandated_repeat_email) {
      return this.setState((prev) => ({
        ...prev,
        error: errors.email_verification
      }))
    }

    this.props.onApplicantSubmit(this.state.applicant)
  }

  render() {
    if (!this.props.age || this.props.courses.length < 1) {
      return null;
    }

    return <React.Fragment>
      <div id="inscripcion"></div>
      <section className="applicant-form">
        <div className="title text-center">
          <h3>Ingresa el resto de tus datos para participar del sorteo de becas</h3>
        </div>
        <form className="container" onSubmit={this.onFormSubmit} onChange={this.onFormChange}>
          {this.props.age >= 18 ? <AdultApplicant error={this.state.error} /> : <UnderAgeApplicant error={this.state.error} /> }
          {
            this.state.error === errors.email_verification
            ? <div className="alert alert-danger text-center" role="alert">
                ¡Las direcciones de correo electronico no coinciden! Por favor, verificalas para poder continuar.
              </div>
            : null
          }
          <div className="text-center">
            <button type="submit" className="btn btn-primary btn-lg">Continuar</button>
          </div>
        </form>
      </section>
    </React.Fragment>
  }
}

export default AspiranteForm;



// WEBPACK FOOTER //
// ./src/components/ApplicantForm/Component.js